import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import { MessageSquare } from 'lucide-react';

export default function AdminSupportPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div><h1 className="text-2xl font-bold text-white">Support Tickets</h1><p className="text-sm text-slate-400">Manage user support requests</p></div>
      <Card><CardContent className="py-8 text-center text-slate-500 text-sm">
        <MessageSquare className="w-8 h-8 mx-auto mb-2 text-slate-600" />
        Support ticket system. Tickets will appear here when users create them.
      </CardContent></Card>
    </div>
  );
}
